import {GridRowModel} from '@mui/x-data-grid-pro';
import {ReactComponent as DragAndDrop} from '../assests/svg/drag-and-drop.svg';
import {t} from 'i18next';
import {Typography} from '@mui/material';
import {GridRenderCellParams, useGridApiContext} from '@mui/x-data-grid';
import AurCheckbox from '../components/common/aur-checkbox/AurCheckbox';
import {CustomGridColDef} from '../components/common/aur-data-grid-pro/AurDataGridPro';
import { generateRandomNumber } from './utils';

export const DEFAULT_TEXT_COLOR = '#FCFCFD';
export const DEFAULT_BACKGROUND_COLOR = '#15181C';

export interface Terms {
  id: number;
  textColor: string;
  backgroundColor: string;
  term: string;
  termId?: string;
}

export const updateRowPosition = (
  initialIndex: number,
  newIndex: number,
  rows: Array<GridRowModel>
): Promise<Terms[]> => {
  return new Promise((resolve) => {
    setTimeout(
      () => {
        const rowsClone = [...rows];
        const row = rowsClone.splice(initialIndex, 1)[0];
        rowsClone.splice(newIndex, 0, row);
        resolve(rowsClone as Terms[]);
      },
      generateRandomNumber() * 500 + 100
    );
  });
};
export const CustomRowReorderIcon = () => {
  return <DragAndDrop aria-hidden="true" />;
};

//commenting this code as this is unused
// const renderNumberHeader = () => {
//   return (
//     <div className="aur-datagrid-number-header-style">
//       <Typography className="typo-text label2_size header-color">#</Typography>
//     </div>
//   );
// };

const renderTermsHeader = () => {
  return (
    <div className="sort-img-header-div aur-datagrid-search-box-column-separator aur-datagrid-number-header-style">
      <Typography className="typo-text label2_size header-color">
        {t('eca.searchTermReport.termsContent.terms')}
      </Typography>
    </div>
  );
};

const renderHighlighterHeader = () => {
  return (
    <div
      className="sort-img-header-div aur-datagrid-search-box-column-separator"
    >
      <span className="sr-only">
        {t('eca.searchTermReport.termsContent.highlightColor')}
      </span>
    </div>
  );
};

const renderIdCell = (params: GridRenderCellParams) => {
  const {row, id} = params;
  const {term} = row;
  const rowIndex = params.api.getAllRowIds().indexOf(params.id);
  const isChecked = params.api.isRowSelected(term);
  const handleCheckboxChange = () => {
    const selectedRows = params.api.getSelectedRows();
    if (selectedRows.has(term)) {
      selectedRows.delete(term);
    } else {
      selectedRows.set(term, row);
    }
    params.api.setRowSelectionModel([...selectedRows.keys()]);
  };

  return (
    <>
      <span className="id-label-span">{rowIndex + 1}</span>
      <AurCheckbox
        sx={{
          marginRight: '6px',
        }}
        checked={isChecked}
        onChange={handleCheckboxChange}
        data-testid={`terms-data-${id}`}
        inputProps={{
          'aria-label': `${t('eca.searchTermReport.termsContent.selectTerm')} ${term}`,
        }}
      />
    </>
  );
};

const renderIdHeader = () => {
  const gridAPIRef = useGridApiContext();
  const selectedCount = gridAPIRef.current.getSelectedRows().size;
  const totalRows = gridAPIRef.current.getRowsCount();

  const isChecked = selectedCount === totalRows && totalRows > 0;
  const isIndeterminate = selectedCount > 0 && selectedCount < totalRows;

  const handleSelectAll = () => {
    if (isChecked) {
      gridAPIRef.current.setRowSelectionModel([]); // Unselect all
    } else {
      const allRowIds = gridAPIRef.current.getAllRowIds(); // Select all
      gridAPIRef.current.setRowSelectionModel(allRowIds);
    }
  };

  return (
    <div className="id-column-header">
      <span className="id-label-span">#</span>
      <AurCheckbox
        checked={isChecked}
        indeterminate={isIndeterminate}
        onChange={handleSelectAll}
        inputProps={{
          'aria-label': t('eca.searchTermReport.termsContent.terms'),
        }}
      />
    </div>
  );
};

export const getColumns = (): CustomGridColDef[] => [
  {
    field: 'id',
    sortable: false,
    filterable: false,
    resizable: false,
    minWidth: 100,
    width: 100,
    renderCell: renderIdCell,
    renderHeader: renderIdHeader,
    cellClassName: 'index-checkox-cell',
    headerClassName: 'index-checkbox-header-cell',
    disableTooltip: true,
  },
  {
    field: 'term',
    headerName: t('eca.searchTermReport.termsContent.terms'),
    sortable: false,
    flex: 5,
    renderCell: (params) => (
      <div
        className="typo-text body3_size column-background-styles"
        style={{
          color: params?.row?.textColor,
          backgroundColor: params?.row?.backgroundColor,
          padding: '0 2px 0 2px',
        }}
        id="str-result-term-text"
      >
        {params?.row?.term}
      </div>
    ),
    renderHeader: renderTermsHeader,
  },
  {
    field: 'backgroundColor',
    headerName: '',
    width: 20,
    sortable: false,
    headerClassName: 'no-separator',
    renderCell: (params) => (
      <span
        className="typo-text body3_size column-background-styles"
        style={{
          color: params?.row?.textColor,
          backgroundColor: params?.row?.backgroundColor,
          padding: '0 4px 0 4px',
        }}
      >
        A
      </span>
    ),
    renderHeader: renderHighlighterHeader,
    disableTooltip: true,
  },
];

export const AurDataGridTermsOverlay = () => {
  return (
    <div className="placeholder">
      {t('eca.searchTermReport.termsContent.viewer.placeholder')}
    </div>
  );
};
